// removed by extract-text-webpack-plugin
module.exports = {"feature":"Feature-m__feature___1P21a","icon":"Feature-m__icon___2QdJR","header":"Feature-m__header___2Gyvu","desc":"Feature-m__desc___hQIzc"};


//////////////////
// WEBPACK FOOTER
// ./components/feature/Feature.m.sass
// module id = WVab
// module chunks = 0